import { render, staticRenderFns } from "./PricingPackages.vue?vue&type=template&id=abd8f0e6"
import script from "./PricingPackages.vue?vue&type=script&lang=js"
export * from "./PricingPackages.vue?vue&type=script&lang=js"
import style0 from "./PricingPackages.vue?vue&type=style&index=0&id=abd8f0e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports